const API_BASE_URL = process.env.REACT_APP_API_URL || "https://mern-blog-app-ef2s.onrender.com" 

export default API_BASE_URL